export const summaryData = {
  private: {
    brandRegistrationFee: '$4.50',
    brandRegistrationFeeCount: 4.5,
    campaignVerificationFee: '$15.00',
    campaignVerificationFeeCount: 15,
    useCaseFee: '$1.50/month',
    useCaseFeeCount: 1.5,
  },
  public: {
    brandRegistrationFee: '$46.00',
    brandRegistrationFeeCount: 46,
    campaignVerificationFee: '$15.00',
    campaignVerificationFeeCount: 15,
    useCaseFee: '$10.00 / month',
    useCaseFeeCount: 10,
  },
}
